import React, { useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, useMediaQuery } from '@mui/material';
import AddTaskIcon from '@mui/icons-material/AddTask';
import './Index.css';
import axios from 'axios';
import MaterialNotifyComponent from '../MaterialNotifyComponent';
import { getAuthenticationToken } from '../../utils/TokenHandler';
import { withRouter } from 'react-router-dom';

var dflag = true;

const footerButtonStyle = {
    display: 'inline-block',
    padding: '0px 20px',
    width: '100%'
};
const formButtonElementStyle = {
    margin: "10px 0",
    backgroundColor: '#014171',
    fontSize: 'x-large',
    boxShadow: '0px 10px 20px 5px rgba(255, 255, 255, 0.2)'
};
const footerButtonContainerStyle = {
    display: 'flex',
    justifyContent: 'space-evenly',
    position: 'fixed', left: '0',
    bottom: '0', width: '100%',
    zIndex: '1'
};
class Wheel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedItem: null,
            btnEnable: true,
            opendialog: false,
            open: false,
            messageNotify: { severity: "warning", message: "", open: false },
            winWheel: {}
        };
        this.selectItem = this.selectItem.bind(this);
        this.places = [{ name: 'جایزه اول' }, { name: 'جایزه دوم' }, { name: 'جایزه سوم' }, { name: 'جایزه چهارم' }];
        this.placesForChanceCoefficient = [];
    }

    componentDidMount() {
        this.setState((old) => {
            return { ...old, open: true };
        });
        axios.get('/api/v1/WinWheel/GetWinWheel', {
            params: {
                customerId: getAuthenticationToken().userID
            }
        }).then((res) => {
            this.setState((old) => {
                return { ...old, winWheel: res.data, btnEnable: !res.data.isActiveForThisUser };
            });
            this.places = res.data.winWheelPrizes.map((item, index) => item);
            res.data.winWheelPrizes.forEach((item, index) => {
                for (let i = 0; i < item.chanceCoefficient; i++)
                    this.placesForChanceCoefficient.push(item);
            });
        }).catch((e) => {
            this.setState((old) => {
                return {
                    ...old,
                    messageNotify: {
                        severity: "error",
                        message: "خطا در فراخوانی اطلاعات از سرور",
                        open: true
                    }
                };
            });
        }).finally(() => {
            this.setState((old) => {
                return { ...old, open: false };
            });
        });
    }

    selectItem() {
        if (this.state.selectedItem === null) {
            let selectedItemForChanceCoefficient = Math.floor(Math.random() * this.placesForChanceCoefficient.length);
            const selectedItem = this.places.findIndex((x) => this.placesForChanceCoefficient[selectedItemForChanceCoefficient].id === x.id);
            if (this.props.onSelectItem) {
                this.props.onSelectItem(selectedItem);
            }
            this.setState((old) => { return { ...old, selectedItem: selectedItem }; });
        } else {
            this.setState((old) => { return { ...old, selectedItem: null }; });
            setTimeout(this.selectItem, 500);
        }
    }

    render() {
        const { selectedItem } = this.state;
        const items = this.places;

        const wheelVars = {
            '--nb-item': items.length,
            '--selected-item': selectedItem,
        };
        const spinning = selectedItem !== null ? 'spinning' : '';
        return (<>
            <div className="wheel-container">
                <div className={`wheel ${spinning}`} style={wheelVars} /*onClick={this.selectItem}*/>
                    {items.map((item, index) => (
                        <div className="wheel-item" key={index} style={{ '--item-nb': index }}>
                            {item.name}
                        </div>
                    ))}
                </div>
            </div>
            <Button disabled={this.state.btnEnable} className="wheel-button" onClick={(e) => {
                this.setState((old) => {
                    return { ...old, btnEnable: true };
                });
                this.selectItem();
                setTimeout(() => {
                    axios.post('/api/v1/WinWheel/AddWinWheelPrizeWinner', {
                        customerId: getAuthenticationToken().userID,
                        winWheelPrizeId: this.places[this.state.selectedItem].id
                    }).then(response => {
                        if (response.data === true) {
                            this.setState((old) => {
                                return { ...old, opendialog: true };
                            });
                        } else {
                            this.setState((old) => {
                                return {
                                    ...old,
                                    messageNotify: {
                                        severity: "error",
                                        message: "خطا در ارسال اطلاعات به سرور",
                                        open: true
                                    }
                                    , btnEnable: false
                                };
                            });
                        }
                    }).catch((e) => {
                        this.setState((old) => {
                            return {
                                ...old,
                                messageNotify: {
                                    severity: "error",
                                    message: "خطا در ارسال اطلاعات به سرور",
                                    open: true
                                }
                            };
                        });
                    }).finally(() => {
                    })
                }, 5000);
            }} color="primary" variant="contained" endIcon={<AddTaskIcon />}> گردنه رو بگردون </Button>

            <div style={footerButtonContainerStyle}>
                <div style={footerButtonStyle}>
                    <Button
                        onClick={() => { this.props.history.push('/') }}
                        id="cancel"
                        name="cancel"
                        variant="contained"
                        color="success"
                        fullWidth
                        style={formButtonElementStyle}>انصراف</Button>
                </div>
            </div>
            {/* <ReactPlayer playing={true} fullScreen={true} url={videoFilePath} width="100%" height="100%" controls={true} /> */}
            <Dialog
                fullScreen={false}
                open={this.state.opendialog}
                onClose={() => alert('onClose')}
                aria-labelledby="responsive-dialog-title"
                style={{ direction: 'rtl' }}
            >
                <DialogTitle id="responsive-dialog-title">
                    {(this.places[this.state.selectedItem] ? (this.places[this.state.selectedItem].winWheelPrizeType === 0 ? "متاسفم!" : "!تبریک") : "")}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {(this.places[this.state.selectedItem] ?
                            (this.places[this.state.selectedItem].winWheelPrizeType === 0 ?
                                "این بار شانس شما " + this.places[this.state.selectedItem]?.name + " بود. بازم بیا شانستو امتحان کن"
                                : (this.places[this.state.selectedItem].winWheelPrizeType === 2 ?
                                    "شما برنده جایزه " + this.places[this.state.selectedItem]?.otherPrizeName + " شده اید" :
                                    "شما برنده جایزه " + this.places[this.state.selectedItem]?.name + " شده اید"))
                            : "")}

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={() =>
                        this.setState((old) => {
                            return { ...old, opendialog: false };
                        })}>
                        بستن
                    </Button>
                </DialogActions>
            </Dialog>
            <MaterialNotifyComponent
                onclose={() => {
                    this.setState((old) => {
                        return { ...old, messageNotify: { ...this.state.messageNotify, open: false } };
                    })
                }}
                open={this.state.messageNotify.open}
                severity={this.state.messageNotify.severity}
                message={this.state.messageNotify.message} />
        </>
        );
    }
}
export default withRouter(Wheel);